import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
};

export type AvailableContentItem = {
  __typename?: 'AvailableContentItem';
  cmsSystemId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  illustration: Scalars['String']['output'];
  title: Scalars['String']['output'];
  topics: Array<AvailableContentTopic>;
  type: ContentType;
};

export type AvailableContentTopic = {
  __typename?: 'AvailableContentTopic';
  code: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ContentArticle = {
  __typename?: 'ContentArticle';
  _type: Scalars['String']['output'];
  body?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum ContentType {
  Article = 'article'
}

export type Query = {
  __typename?: 'Query';
  articleById?: Maybe<ContentArticle>;
  getAllAvailableContent: Array<AvailableContentItem>;
};


export type QueryArticleByIdArgs = {
  id: Scalars['String']['input'];
};

export enum ReferralInviteStatus {
  Completed = 'completed',
  Pending = 'pending'
}

export enum ReferralSessionStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Expired = 'expired',
  Pending = 'pending'
}

export enum ReferralStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Pending = 'pending'
}

export type ArticleByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArticleByIdQuery = { __typename?: 'Query', articleById?: { __typename?: 'ContentArticle', id: string, title: string, image?: string | null, body?: any | null, _type: string } | null };

export type GetAllAvailableContentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAvailableContentQuery = { __typename?: 'Query', getAllAvailableContent: Array<{ __typename?: 'AvailableContentItem', id: string, cmsSystemId: string, illustration: string, title: string, type: ContentType, topics: Array<{ __typename?: 'AvailableContentTopic', code: string, title: string }> }> };


export const ArticleByIdDocument = gql`
    query ArticleById($id: String!) {
  articleById(id: $id) {
    id
    title
    image
    body
    _type
  }
}
    `;

export function useArticleByIdQuery(options: Omit<Urql.UseQueryArgs<ArticleByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ArticleByIdQuery, ArticleByIdQueryVariables>({ query: ArticleByIdDocument, ...options });
};
export const GetAllAvailableContentDocument = gql`
    query GetAllAvailableContent {
  getAllAvailableContent {
    id
    cmsSystemId
    illustration
    title
    type
    topics {
      code
      title
    }
  }
}
    `;

export function useGetAllAvailableContentQuery(options?: Omit<Urql.UseQueryArgs<GetAllAvailableContentQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAllAvailableContentQuery, GetAllAvailableContentQueryVariables>({ query: GetAllAvailableContentDocument, ...options });
};